import { render } from "./ModalComponent.vue?vue&type=template&id=68a4e310&ts=true"
import script from "./ModalComponent?vue&type=script&lang=ts"
export * from "./ModalComponent?vue&type=script&lang=ts"

import "./_assets/_modal.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/runner/work/xebel/xebel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__